<div class="color-bar"></div>
<div class="conteudo ml-2 mr-2">
  <div class="row caixa-filtros shadow-sm">
    <div class="col-3">
      <app-commercial-atacado-filtro (filtroAlterado)="onKey($event)" [filtros]="filtros">
      </app-commercial-atacado-filtro>
    </div>
    <div class="col-5">
      <h5 class="text-center mt-2" translate>
        {{'commercial.commercialAtacado.titulo'}}
      </h5>
    </div>
    <div class="col-4">
      <app-barra-consulta-ajuda></app-barra-consulta-ajuda>
    </div>
  </div>
  <!-- <app-loading [exibir]="carregando"></app-loading> -->
  <div *ngIf="!carregando">
    <div class="mt-3">
      <div class="row">
        <div class="col-8 tirap">
          <button [disabled]="!filtroconsolidado" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloPcaConsolidado' | translate}}"
            (click)="consolidado($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtropecas" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloPecas' | translate}}" (click)="pecas($event)"
            class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtroroupas" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloRoupas' | translate}}"
            (click)="roupas($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtroacessorios" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloAcessorios' | translate}}"
            (click)="acessorios($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
        </div>
        <div class="col-4">
          <button class="btn btn-outline-secondary btn-sm mb-2 ml-2 float-right" (click)="exportarExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export Excel
          </button>
        </div>
      </div>
    </div>
    <div class="content">
      <div id="excel-table">
        <nav class="topo-abas">
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a id="dados-principais-tab1" href="#dados-principais1" aria-controls="dados-principais1"
              aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab" translate>
              {{'commercial.commercialAtacado.abaPrincipal.abaTitulo'}}
            </a>
            <a id="dados-quarters-tab1" href="#dados-quarters1" aria-controls="dados-quarter1s" aria-selected="false"
              class="nav-item nav-link" data-toggle="tab" role="tab">
              Quarters
            </a>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div id="dados-principais1" aria-labelledby="dados-principais-tab1" class="tab-pane fade show active"
            role="tabpanel">
            <p-table [columns]="colsTable1" [value]="comercialAtacado.dados" [loading]="loading"
              responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
              id="excel-table" [autoLayout]="true" class="style">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th [translate]="getTranslate(titulo)" class="text-center" colspan="2">{{titulo}}</th>
                  <th translate class="text-center" colspan="5">
                    {{'commercial.commercialAtacado.abaPrincipal.ano'}}</th>
                </tr>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [translate]="getTranslate(col.header)">
                    {{col.header}}
                    <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dados let-columns="columns">
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.field == 'pendente'" [ngStyle]="{'color': dados.pendente < 0 ? 'red' : 'black'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field == 'pendente_ytd'"
                      [ngStyle]="{'color': dados.pendente_ytd < 0 ? 'red' : 'black'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field != 'pendente' && col.field != 'pendente_ytd'">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr class="tr-footer styles">
                  <td></td>
                  <td [translate]="getTranslate(nome_dealer)">{{nome_dealer}}</td>
                  <td>{{budget | currency: ' '}}</td>
                  <td>{{budget_ytd | currency: ' '}}</td>
                  <td>{{realizado | currency: ' '}}</td>
                  <td>{{pendente | currency: ' '}}</td>
                  <td>{{pendente_ytd | currency: ' '}}</td>
                </tr>
              </ng-template>
            </p-table>

          </div>
          <div id="dados-quarters1" aria-labelledby="dados-quarters-tab1" class="tab-pane fade" role="tabpanel">
            <p-table [columns]="colsQuarters" [value]="comercialAtacado.dados" [loading]="loading"
              responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
              id="excel-table" [autoLayout]="true" class="style">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th class="text-center" colspan="14">Quarters</th>
                </tr>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [translate]="getTranslate(col.header)"
                    [ngStyle]="{'width': col.width}">
                    {{col.header}}
                    <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dados let-columns="columns">
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.field == 'q1_percentual'"
                      [ngStyle]="{'color': dados.q1_percentual> 1 ? 'black' : 'red'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field == 'q2_percentual'"
                      [ngStyle]="{'color': dados.q2_percentual> 1 ? 'black' : 'red'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field == 'q3_percentual'"
                      [ngStyle]="{'color': dados.q3_percentual> 1 ? 'black' : 'red'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field == 'q4_percentual'"
                      [ngStyle]="{'color': dados.q4_percentual> 1 ? 'black' : 'red'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td
                      *ngIf="col.field != 'q1_percentual' && col.field != 'q2_percentual' && col.field != 'q3_percentual' && col.field != 'q4_percentual'">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr class="tr-footer styles">
                  <td [translate]="getTranslate(nome_dealer)">{{nome_dealer}}</td>
                  <td>{{q1_previsao | currency: ' '}}</td>
                  <td>{{q1_realizado | currency: ' '}}</td>
                  <td>{{q1_percentual | percent: '1.0-0'}}</td>
                  <td>{{q2_previsao | currency: ' '}}</td>
                  <td>{{q2_realizado | currency: ' '}}</td>
                  <td>{{q2_percentual | percent: '1.0-0'}}</td>
                  <td>{{q3_previsao | currency: ' '}}</td>
                  <td>{{q3_realizado | currency: ' '}}</td>
                  <td>{{q3_percentual | percent: '1.0-0'}}</td>
                  <td>{{q4_previsao | currency: ' '}}</td>
                  <td>{{q4_realizado | currency: ' '}}</td>
                  <td>{{q4_percentual | percent: '1.0-0'}}</td>
                </tr>
              </ng-template>
            </p-table>

          </div>
        </div>
        <nav class="topo-abas">
          <div class="nav nav-tabs" id="nav-tab" role="tablist" style="margin-top: 1rem">
            <a id="dados-principais-tab2" href="#dados-principais2" aria-controls="dados-principais2"
              aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab" translate>
              {{'commercial.commercialAtacado.abaPrincipal.abaTitulo'}}
            </a>
            <a id="dados-historico-tab" href="#dados-historico" aria-controls="dados-historico" aria-selected="false"
              class="nav-item nav-link" data-toggle="tab" role="tab" translate>
              {{'commercial.commercialAtacado.abaHistorico.abaTitulo'}}
            </a>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div id="dados-principais2" aria-labelledby="dados-principais-tab2" class="tab-pane fade show active"
            role="tabpanel">
            <p-table [columns]="colsTable2" [value]="comercialAtacadoTab2.dados" [loading]="loading"
              responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
              id="excel-table" [autoLayout]="true" class="style">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th [translate]="getTranslate(titulo)" class="text-center" colspan="2">{{titulo}}</th>
                  <th translate class="text-center" colspan="5">
                    {{'commercial.commercialAtacado.abaPrincipal.mes'}}</th>
                </tr>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [translate]="getTranslate(col.header)">
                    {{col.header}}
                    <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dados let-columns="columns">
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.field == 'gap_mes'" [ngStyle]="{'color': dados.gap_mes < 0 ? 'red' : 'black'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field == 'gap_mes_mtd'"
                      [ngStyle]="{'color': dados.gap_mes_mtd < 0 ? 'red' : 'black'}">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                    <td *ngIf="col.field != 'gap_mes' && col.field != 'gap_mes_mtd'">
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr class="tr-footer styles">
                  <td></td>
                  <td [translate]="getTranslate(nome_dealer)">{{nome_dealer}}</td>
                  <td>{{budgetTab2 | currency: ' '}}</td>
                  <td>{{budgetTab2_mtd | currency: ' '}}</td>
                  <td>{{realizadoTab2 | currency: ' '}}</td>
                  <td>{{gap_mes | currency: ' '}}</td>
                  <td>{{gap_mes_mtd | currency: ' '}}</td>
                </tr>
              </ng-template>
            </p-table>

          </div>
          <div id="dados-historico" aria-labelledby="dados-historico-tab" class="tab-pane fade" role="tabpanel">
            <p-table [columns]="colsHistory" [value]="comercialAtacadoTab2.dados" [loading]="loading"
              responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
              id="excel-table" [autoLayout]="true" class="style">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th translate class="text-center" colspan="14">
                    {{'commercial.commercialAtacado.abaHistorico.historico'}}</th>
                </tr>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [translate]="getTranslate(col.header)">
                    {{col.header}}
                    <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dados let-columns="columns">
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <td>
                      {{col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <ng-container *ngIf="marcas === 'Triumph'">
                  <tr class="tr-footer styles">
                    <td [translate]="getTranslate(nome_dealer)">{{nome_dealer}}</td>
                    <td>{{jul | currency: ' '}}</td>
                    <td>{{ago | currency: ' '}}</td>
                    <td>{{sete | currency: ' '}}</td>
                    <td>{{outr | currency: ' '}}</td>
                    <td>{{nov | currency: ' '}}</td>
                    <td>{{dez | currency: ' '}}</td>
                    <td>{{jan | currency: ' '}}</td>
                    <td>{{fev | currency: ' '}}</td>
                    <td>{{mar | currency: ' '}}</td>
                    <td>{{abr | currency: ' '}}</td>
                    <td>{{mai | currency: ' '}}</td>
                    <td>{{jun | currency: ' '}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="marcas !== 'Triumph'">
                  <tr class="tr-footer styles">
                    <td [translate]="getTranslate(nome_dealer)">{{nome_dealer}}</td>
                    <td>{{jan | currency: ' '}}</td>
                    <td>{{fev | currency: ' '}}</td>
                    <td>{{mar | currency: ' '}}</td>
                    <td>{{abr | currency: ' '}}</td>
                    <td>{{mai | currency: ' '}}</td>
                    <td>{{jun | currency: ' '}}</td>
                    <td>{{jul | currency: ' '}}</td>
                    <td>{{ago | currency: ' '}}</td>
                    <td>{{sete | currency: ' '}}</td>
                    <td>{{outr | currency: ' '}}</td>
                    <td>{{nov | currency: ' '}}</td>
                    <td>{{dez | currency: ' '}}</td>
                  </tr>
                </ng-container>
              </ng-template>
            </p-table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
